import { Stack, Autocomplete, TextField } from "@mui/material"


export const GeneralData = ({ formValues, handleInputChange }) => {

    const { status, iva, paymentMethod, characteristics } = formValues;

    return (
        <Stack flexDirection='row' width='90%' justifyContent='space-between' flexWrap='wrap' gap={3} mt='1rem' >
            <Stack flexDirection='row' width='100%' justifyContent='space-between'>
                <Autocomplete
                    options={statusOptions}
                    sx={{ width: '30%' }}
                    size='small'
                    value={statusOptions.includes(status) ? status : null}
                    onChange={(event, newValue) => {
                        handleInputChange({ target: { name: 'status', value: newValue || '' } });
                    }}
                    renderInput={(params) => <TextField {...params} label="Estado" required />}
                />
                <Autocomplete
                    options={ivaOptions}
                    sx={{ width: '30%' }}
                    size='small'
                    value={ivaOptions.includes(iva) ? iva : null}
                    onChange={(event, newValue) => {
                        handleInputChange({ target: { name: 'iva', value: newValue || '' } });
                    }}
                    renderInput={(params) => <TextField {...params} label="IVA" required />}
                />
                <TextField
                    sx={{ width: '30%' }}
                    label="Forma de pago"
                    type="search"
                    variant="outlined"
                    name='paymentMethod'
                    size='small'
                    value={paymentMethod}
                    onChange={handleInputChange}
                    required
                />
            </Stack>
            <Stack flexDirection='row' width='100%' justifyContent='space-around'>
                <TextField
                    label="Caracteristicas"
                    type="search"
                    variant="filled"
                    fullWidth
                    name='characteristics'
                    value={characteristics}
                    onChange={handleInputChange}
                    required
                    multiline
                />
            </Stack>
        </Stack>
    )
}

const statusOptions = ['Pendiente de montaje', 'Montada', 'Pendiente de desmontaje', 'Pendiente de recogida', 'Terminada', ''];
const ivaOptions = ['10%', '21%', ''];